import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { SystemStatus } from '@backend/api/system-status/models/system-status';
import { SKIP_CONNECTIVITY_TRACKING } from '@core/health-check/connectivity.model';

@Injectable({
  providedIn: 'root',
})
export class SystemStatusApiService {
  constructor(private http: HttpClient) {
  }

  get() {
    return this.http.get<SystemStatus>('status');
  }

  healthCheck() {
    // Проба доступности: помечена так, чтобы ConnectivityInterceptor её не учитывал.
    return this.http.get('health-check', {
      context: new HttpContext().set(SKIP_CONNECTIVITY_TRACKING, true),
    });
  }
}
